import styled, {ThemeProps} from 'styled-components';

import {Theme} from '../../../../theme/types';
import {Column, Row, SectionDefaultStyles, ColumnStyles, RowW100Styles} from '../Layouts/Layouts';

export const MainContentWrapperStyle = styled.div(
  (props: ThemeProps<Theme>) => `
  ${ColumnStyles}
  padding: ${props.theme.spacing.xxlarge};
  width: 100%;
`,
);

export const ViewMoreTextStyled = styled.a(
  props => `
  color: ${props.theme.colors.goBrandBlue.base};
  font-size: ${props.theme.font.custom(16)};
  cursor: pointer;
  padding: 10px;
  align: right;
  text-align: end;
`,
);

export const ContentWrapper = styled.div(
  (props: ThemeProps<Theme>) => `
  font-size: ${props.theme.font.custom(16)};
  line-height: 1.4;
  overflow: hidden;
  height: ${props.height}
`,
);
